var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7342 7.31673C11.7342 8.82679 10.5095 10.0506 8.99946 10.0506C7.48941 10.0506 6.26562 8.82679 6.26562 7.31673C6.26562 5.80582 7.48941 4.58203 8.99946 4.58203C10.5095 4.58203 11.7342 5.80582 11.7342 7.31673Z",
    stroke: "#A4A7B7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99827 13.6305C12.2917 13.6305 15.304 11.2625 17 7.31524C15.304 3.368 12.2917 1 8.99827 1H9.00173C5.70832 1 2.696 3.368 1 7.31524C2.696 11.2625 5.70832 13.6305 9.00173 13.6305H8.99827Z",
    stroke: "#A4A7B7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.a0e52a4bfa95bb4833acc32cc2833bed.svg";
export { ForwardRef as ReactComponent };